import { DecisionDetail } from "../../../models/home";
import { buildAction, buildConfidence, buildPriority, buildRisk, isoFromNow } from "./home-qa-harness.builders";

export const DISABLED_DETAIL: DecisionDetail = {
  decision: {
    decisionId: "detail-disabled",
    state: "waiting",
    title: "Finalize vendor onboarding sync",
    shortReason: "The action is valid but it is waiting for the downstream connector window.",
    documents: [
      {
        documentId: "doc-detail-disabled",
        classificationId: "class-detail-disabled",
        title: "Vendor onboarding packet"
      }
    ],
    nextBestAction: buildAction("sync_vendor", "Sync vendor record", false, {
      disabledReason: "Awaiting external approval from the ERP connector.",
      description: "Run the sync once the downstream connector becomes available.",
      payloadSchema: {
        type: "object",
        required: ["vendorId"]
      }
    }),
    availableActions: [
      buildAction("sync_vendor", "Sync vendor record", false, {
        placement: "primary",
        executionMode: "detail",
        disabledReason: "Awaiting external approval from the ERP connector.",
        description: "Run the sync once the downstream connector becomes available.",
        completionCriteria: ["Validate evidence", "Confirm destination system"]
      })
    ],
    priority: buildPriority(64, "medium", "The onboarding can wait until the current approval cycle ends."),
    risk: buildRisk("medium", "Vendor activation remains paused until the sync succeeds."),
    confidence: buildConfidence(0.87),
    evidence: [
      {
        evidenceId: "evidence-disabled-1",
        type: "connector",
        label: "ERP status",
        value: "Pending approval",
        confidence: 0.99,
        source: "erp-connector",
        occurredAt: isoFromNow(-1)
      }
    ],
    missingInformation: [],
    owner: { userId: "u-3", displayName: "Procurement" },
    dueAt: isoFromNow(120),
    updatedAt: isoFromNow(-1),
    traceId: "detail-disabled-trace",
    sourceTrace: {
      traceId: "detail-disabled-trace",
      actionSource: "policy-engine",
      confidenceSource: "vendor-classifier",
      explanationSource: "connector-status",
      evaluatorVersion: "2026.05.10",
      rulesVersion: "home-ia-v3"
    }
  },
  activityPreview: [
    {
      eventId: "activity-disabled-1",
      decisionId: "detail-disabled",
      documentIds: ["doc-detail-disabled"],
      type: "decision.updated",
      title: "Connector dependency detected",
      narrative: "The action moved to waiting after the ERP approval window closed.",
      occurredAt: isoFromNow(-4)
    }
  ],
  relatedDecisionIds: []
};
